import { Panier } from '@europrocurement/l2d-modules';
import React from 'react';

import { useParams } from 'react-router';

const PagePanier: React.FunctionComponent = function () {
    const { uuid } = useParams();

    if (!uuid || uuid.trim() === '') {
        throw new Error('uuid is required');
    }

    return <Panier uuid={uuid} />;
};
export default PagePanier;
